<template>
  <div class="curriculum">
    <div class="container">
      <div class="row">
        <div class="heading col col-6">
          <h2 class="h2 curriculum-heading">
            {{ title }}
          </h2>
          <span>
            {{ subtitle }}
          </span>
        </div>
        <div class="col col-12 module-holder">
          <div class="module" :class="{ expand: moduleSeeMore && $store.state.layout === 'mobile' }">
            <div v-if="$store.state.layout === 'mobile'" class="module-see-more">
              <div @click.prevent="moduleSeeMore = !moduleSeeMore">
                <span v-if="moduleSeeMore">See Less <IconArrowDown /></span>
                <span v-else class="expand">See More <IconArrowDown /></span>
              </div>
            </div>
            <div class="module-body">
              <h3 class="h3">
                {{ course.name }}
              </h3>
              <p class="body-2">
                {{ course.curriculumDescription }}
              </p>
              <div class="module-info">
                <div v-for="(group, idx) in dataStructure()" :key="idx" class="course col-6">
                  <div v-for="(section, ic) in group" :key="ic">
                    <div class="course-info">
                      <span class="number">{{ ('0' + getSectionIdx(section.sectionName)).slice(-2) }}</span>
                      <span class="name" :title="section.sectionName">{{ section.sectionName }}</span>
                      <span class="lessons">{{ `${section.lessons}${section.lessons > 1 ? ' lessons' : ' lesson' }` }}</span>
                    </div>
                    <hr>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="benefit-holder col-6 col">
          <div class="benefit">
            <h2>
              Who Can Benefit from This Course
            </h2>
            <p class="body-1">
              {{ course.benefitDescription }}
            </p>
          </div>
          <div class="col-8 col sm-6 btn-info">
            <button class="btn-primary btn-lg" @click="$router.push({ path: '/checkout/', query: { plan: course.plan, coupon: $route.query.coupon } })">
              Buy Now For ${{ course.discountedPrice }}
            </button>
            <p>
              Billed once. Lifetime access to all course materials and updates
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconArrowDown from '../../assets/svg/icon-expand.svg?vue-component';

export default {
  components: {
    IconArrowDown,
  },
  props: {
    c: { type: Object, default: () => {}, required: true },
  },
  data() {
    return {
      moduleSeeMore: false,
      course: this.c || {},
      title: this.c.curriculumTitle || 'Beginner-Friendly Curriculum Designed with your Practical Needs in Mind',
      subtitle: this.c.curriculumSubTitle || 'Learn in-demand skills with a structured course that prepares you for the world of data science as it is today.',
    };
  },
  methods: {
    dataStructure() {
      const cols = this.$store.state.layout === 'desktop' || this.$store.state.tablet ? 2 : 1;
      const data = this.course.curriculum || [];

      const chunkSize = Math.ceil(data.length / cols);
      const dataArray = [];
      for (let i = 0; i < data.length; i += 1) {
        const chunkIndex = Math.floor(i / chunkSize);

        if (!dataArray[chunkIndex]) {
          dataArray[chunkIndex] = [];
        }

        dataArray[chunkIndex].push(data[i]);
      }
      for (let i = 0; i < dataArray.length; i += 1) {
        dataArray[i] = [...dataArray[i]];
      }

      return dataArray;
    },
    getSectionIdx(name) {
      return this.course.curriculum.findIndex((s) => s.sectionName === name) + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.curriculum {
  .heading {
    text-align: center;
    margin: 0 auto var(--spacing-40);

    .curriculum-heading {
      margin-bottom: var(--spacing-24);
    }

    span {
      color: var(--main-dark-shade-3);
      font-size: 18px;
    }
  }

  .module-holder {
    margin-bottom: var(--spacing-100);

    .module {
      display: block;
      padding: var(--spacing-44);
      background-color: var(--main-light);
      border-radius: 0 0 7px 7px;
      box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);

      .module-mobile {
        display: none;
      }

      .body-2 {
        color: var(--main-dark-shade-3);
        margin-bottom: var(--spacing-60);
      }

      .module-info {
        display: flex;
        flex-wrap: wrap;

        .course {
          width: 50%;

          &:first-of-type {
            padding-right: 66px;
          }

          &:nth-of-type(2) {
            padding-left: 66px;
          }

          > div {
            margin-bottom: 18px;

            hr {
              border: none;
              margin: 0;
            }

            hr:after {
              content: '...................................................................................';
              letter-spacing: 14px;
              font-size: 16px;
              color: rgba(0, 12, 31, 0.36);
            }

            &:last-of-type {
              hr {
                display: none;
              }
            }

            .course-info {
              display: flex;

              .number {
                color: var(--accent);
                margin-right: 11px;
              }

              .name {
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 60%;
              }

              .lessons {
                color: var(--main-dark-shade-3);
                margin-left: auto;
              }
            }
          }
        }
      }
    }
  }

  .benefit-holder {
    margin: var(--spacing-100) auto 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;

    .benefit {
      margin: 0 auto;
      text-align: center;

      h2 {
        margin-bottom: var(--spacing-24);
      }

      .body-1 {
        margin-bottom: var(--spacing-60);
      }
    }

    .btn-info {
      margin: 0 auto;

      .btn-primary {
        margin-bottom: var(--spacing-16);
      }

      p {
        margin: 0 auto;
        color: var(--main-dark-shade-3);
        text-align: center;
      }
    }
  }

  @include bp($bp-mobile) {
    .heading {
      .curriculum-heading,
      span {
        max-width: 100%;
      }
    }

    .module-holder {
      .tabs {
        display: none;
      }

      .module {
        margin-top: var(--spacing-12);
        margin-bottom: var(--spacing-12);
        background: none;
        display: block;
        transition: all var(--duration) ease;
        position: relative;
        max-height: 700px;
        padding: 40px 20px;
        overflow: hidden;
        background-color: var(--main-light);
        border-radius: 7px;

        .module-mobile {
          background: none;
          cursor: initial;
          height: auto;
          margin-bottom: var(--spacing-20);

          span {
            color: var(--main-light);

            svg {
              display: none;
            }
          }
        }

        &.expand {
          max-height: 2500px;

          .module-see-more:after {
            background: none;
          }
        }

        .module-see-more {
          min-height: 20px;
          color: var(--accent);
          margin-top: 10px;
          position: absolute;
          bottom: 20px;
          left: 0;
          width: 100%;

          > div {
            z-index: 1;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }

          span {
            font-weight: 600;
            z-index: 1;

            &:not(.expand) {
              svg {
                transform: rotate(180deg);
              }
            }

            svg {
              margin-left: 10px;

              path[fill] {
                fill: var(--accent);
              }
            }
          }

          &:after {
            content: '';
            position: absolute;
            top: -80px;
            height: 120px;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0) -13.64%, #FFF 66.26%);
          }
        }

        .module-body {
          .h3 {
            max-width: 100%;
            font-size: 20px;
          }

          .body-2 {
            max-width: 100%;
          }

          .module-info {
            .course {
              padding-right: 0 !important;
              padding-left: 0 !important;

              > div {
                .name {
                  max-width: 100%;
                }

                .lessons {
                  display: none;
                }

                &:last-of-type hr {
                  display: block;
                }
              }
            }
          }
        }
      }
    }
  }

  @include bp($bp-phone) {
    .benefit {
      h2 {
        font-size: 28px;
        margin-bottom: var(--spacing-16);
      }

      .body-1 {
        font-size: 18px;
        margin-top: 0;
        margin-bottom: var(--spacing-48);
      }
    }
  }
}
</style>
